import NextLink from 'next/link';
import sanitizeHtml from 'sanitize-html';
import { useRouter } from 'next/router';

import { Box, Flex, Ribbon } from '@thebouqs/ui';
import { McodeRibbonBlockProps } from './McodeRibbonBlock.d';
import { createBouqsCdnIcon } from '@thebouqs/icons';
import RibbonBlockSkeleton from '../RibbonBlock/RibbonBlockSkeleton';

const SaleTag = createBouqsCdnIcon('saleTag');

const MCodeRibbonBlock = (props: McodeRibbonBlockProps): JSX.Element => {
  const {
    data: { text, link_url, background, color },
  } = props;
  const route = useRouter();
  const mcode = route?.query?.mcode as string;

  const textNoTags = sanitizeHtml(text, {
    allowedTags: [],
  });
  const textAroundMcode = textNoTags.split(/{{mcode}}/);

  return props?.data ? (
    <NextLink href={link_url}>
      <Ribbon
        link={link_url}
        backgroundColor={background}
        color={color}
        onClickFn={() => null}
        jsxElement={
          <Flex
            className="mcode-ribbon-block"
            flexDirection={['column', 'row']}
            justifyContent="center"
            align="center">
            <Flex justifyContent="center" align="center">
              <SaleTag
                display={['none', null, 'block']}
                boxSize="6"
                color={color}
                mx="2"
              />
              <Box>{textAroundMcode[0]}</Box>
              <Box p="xs" m="xs" backgroundColor={color} color={background}>
                {mcode}
              </Box>
            </Flex>
            <Box>{textAroundMcode[1]}</Box>
          </Flex>
        }
      />
    </NextLink>
  ) : (
    <RibbonBlockSkeleton />
  );
};

export default MCodeRibbonBlock;
